module.exports = __webpack_public_path__ + "img/spirit_light_grey_ba_list.b70616ec.jpg";